<template>
<v-card flat>
	<v-form ref="domain" v-model="domainValid" lazy-validation>
		<v-card-text class="title mt-10">
			Whitelabel Domain
		</v-card-text>
		<v-divider></v-divider>
		
		<div class="pa-5">
			<div>
				<v-row>
					<v-col cols="12">
						NOTE: Before adding domain name make sure that you have already added CNAME record, name - subdomain.yourwebsite.com and value panel.offersoptimize.com with your domain name provider eg, Godaddy, namecheap, cloudflare etc. For any questions please email us support@trackier.com
					</v-col>
					<v-col cols="12">
						<v-text-field class="border-radius"  v-model="domains.host"   prepend-inner-icon="mdi-web" outlined label="Domain Name" required dense></v-text-field>

					</v-col>
					<v-col cols="12">
						<label>SSL</label>
						<v-radio-group v-model="domains.ssl" row>
							<v-radio label="Yes" value="yes"></v-radio>
							<v-radio label="No" value="no"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col v-if="domains.status">
						<label>Status</label><br>
						<v-chip small class="text-capitalize font-weight-bold" :color="domains.status == 'active' ? 'light-green darken-2' : domains.status == 'completed' ? 'primary' : 'orange accent-4'" :style="domains.status == 'active' ? 'background: #689f3821 !important;' : domains.status == 'completed' ? 'background: #388fc21a !important;' : 'background: #ec6a3312 !important;'" label outlined>
							{{domains.status}}
						</v-chip>
						<v-btn v-if="domains.status != 'active' && domains.status != 'completed'" class="ml-2" :loading="reload" @click="verifyDomain(domains)" icon small><v-icon small>mdi-cached</v-icon></v-btn><br>
						<label v-if="domains.err_message">Error Message : {{domains.err_message}}
						</label>
					</v-col>
					
					
				</v-row>
			</div>
		</div>
		<v-card-actions class="pa-4">
			<v-btn color="primary" class="text-capitalize px-6" v-if="domains.tests != ''" :loading="loading" @click="saveDomain">Save Domain Details</v-btn>
		</v-card-actions>
	</v-form>
</v-card>

</template>

<script>
import {
	mapActions,
	mapMutations
} from "vuex"
export default {
	data: () => ({
		reload: false,
		edited : false,
		editedId : '',
		domains: {
			host: '',
			ssl: ''
		},
		domainValid:true,
		loading: false,
	}),
	
	created() {
		this.initialize()
	},
	methods: {
		...mapActions(['GetResponse', 'PostResponse', 'PatchResponse']),
		...mapMutations(['SnackbarSuccess']),
	
		async initialize() {
			this.edited = false
			this.editedId = ''
			this.reload = true
			try {
				let url = '/internal/v2/domain'
				const data = (await this.GetResponse(url)).data
				if (data.domain) {
					this.edited = true
					this.editedId = data.domain._id
					this.domains = {
						host : data.domain.host,
						ssl : data.domain.protocol == 'https' ? "yes" : "no",
						status : data.domain.status,
						_id : data.domain._id,
						err_message : data.domain.err_message
					}
				}
				this.reload = false
			} catch (err) {
				this.reload = false
			}
		},
		
		
		
		async saveDomain() {
			let dataMsg;
			if (this.$refs.domain.validate()) {
				if (this.edited) {
					delete this.domains.status;
					delete this.domains._id;
					delete this.domains.err_message;
				} 
				let value = {
					url: `/internal/v2/domain${this.edited ? '/' + this.editedId : ''}`,
					data: this.domains
				}
				try {
					const data = (await this.PostResponse(value)).data
					if (data.success) {
						dataMsg = { success: true, message: data.message, action: 'success' }
						this.initialize()
					} else {
						dataMsg = { success: true, message: data.message, action: 'error' }
					}
				} catch (err) {
					dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
				}
				this.loading = false
				this.SnackbarSuccess(dataMsg)
			}
		},
		
		async verifyDomain(item) {
			this.loading = true
			try {
				let url = `/internal/v2/domain-verify/${item._id}`
				const data = (await this.GetResponse(url)).data
			} catch (err) {
				let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
				this.SnackbarSuccess(dataMsg)
			}
			this.loading = false
			this.initialize()
		},
	},
}
</script>


